import { monthBody } from "./monthBody";
import { monthHead } from "./monthHead";
export function monthUI() {
    return `
      <div class="bible-reading__calendar">
        <table>
          <thead>
            <tr>
              ${monthHead()}
            </tr>
          </thead>
          <tbody>
            ${monthBody()}
          </tbody>
        </table>
      </div>
    `;
}
